import { render } from "./ContactButtons.vue?vue&type=template&id=72458581&scoped=true"
import script from "./ContactButtons.vue?vue&type=script&lang=js"
export * from "./ContactButtons.vue?vue&type=script&lang=js"

import "./ContactButtons.vue?vue&type=style&index=0&id=72458581&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72458581"]])

export default __exports__